import { useEffect } from 'react';
import { LISTING_PACKAGE_ANONYM_LISTING_ID } from '../../../marketplace-custom-config';

export const useInitialFormValueForAnonymIntention = ({ form, currentListing }) => {
    const { anonymousListingPackageIntention } = currentListing?.attributes?.publicData || {};

    useEffect(() => {
        if (anonymousListingPackageIntention) {
            form.change(LISTING_PACKAGE_ANONYM_LISTING_ID, true);
        }
    }, [anonymousListingPackageIntention]);
};
